import { useEffect } from "react";

interface UseAutoSendFromUrlProps {
  isActivelyStreaming: boolean;
  conversationLength: number;
  onSearch: (message: string) => void;
}

/**
 * Auto-send message from URL query params
 */
export const useAutoSendFromUrl = ({
  isActivelyStreaming,
  conversationLength,
  onSearch,
}: UseAutoSendFromUrlProps) => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const query = params.get("query");
    const stacklineSku = params.get("stacklineSku");

    if (query && !isActivelyStreaming && conversationLength === 0) {
      // Construct the message with stacklineSku if provided
      let messageToSend = query;
      if (stacklineSku) {
        messageToSend = `<product featured="true" stacklineSku="${stacklineSku}" question="${query}" />`;
      }

      // Auto-send the message
      onSearch(messageToSend);

      // Clear the URL params after sending
      params.delete("query");
      params.delete("stacklineSku");
      const newUrl = params.toString()
        ? `${window.location.pathname}?${params.toString()}`
        : window.location.pathname;
      window.history.replaceState({}, "", newUrl);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isActivelyStreaming, conversationLength]);
};
